import React from 'react';
import { packItems, volumes, volumesIntro } from '../data/content';
export function WhatsInside() {
  return <section id="inside" className="w-full bg-paper px-8 py-24 sm:px-14 sm:py-32" data-id="element-220" data-mp="yuzd8p9ivcb2">
      <div className="mx-auto max-w-6xl" data-id="element-221" data-mp="kwra1zlw7erg">
        <h2 className="mx-auto max-w-3xl text-center font-display text-[2.6rem] leading-[1.02] tracking-tight text-ink sm:text-6xl" data-id="element-222" data-mp="kvzozipx8zff">
          Que contient le pack <em className="text-pen" data-id="element-223" data-mp="b5wlgol6c32u">SCIENCES PRÊTES™</em>&nbsp;?
        </h2>

        <div className="mt-16 grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-224" data-mp="fx4uvkmi7og0">
          <h3 className="font-display text-3xl leading-tight text-ink sm:text-4xl lg:col-span-6" data-id="element-225" data-mp="fyg0lpzif69r">
            {volumesIntro.title}
          </h3>
          <p className="text-lg leading-relaxed text-ink/75 lg:col-span-6" data-id="element-226" data-mp="74bfln724p25">{volumesIntro.text}</p>
        </div>

        <ol className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-id="element-227" data-mp="3ocolsczpcurw">
          {volumes.map(volume => {
          const Icon = volume.icon;
          return <li key={volume.number} className={`flex h-64 flex-col rounded-lg p-4 shadow-[inset_-8px_0_0_rgba(0,0,0,0.1),0_18px_30px_-20px_rgba(20,32,61,0.7)] sm:h-72 lg:h-80 ${volume.spine}`} data-id="element-228" data-mp="3ctedkbvlzb3r">
                <span className="text-xs font-semibold opacity-80" data-id="element-229" data-mp="3lu2imh30y14i">{volume.number}</span>
                <span className="mt-1 font-display text-4xl leading-none" data-id="element-230" data-mp="3hubtsix25v2m">{volume.level}</span>
                <Icon className="mt-6 h-7 w-7 opacity-90" aria-hidden="true" data-id="element-231" data-mp="2u47rcevlw1d7" />
                <span className={`mt-auto border-t pt-3 text-sm font-medium leading-snug ${volume.rule}`} data-id="element-232" data-mp="2p54lis7sxr46">
                  {volume.title}
                </span>
              </li>;
        })}
        </ol>

        <ul className="mt-20 grid gap-x-8 gap-y-12 border-t border-ink/15 pt-12 sm:grid-cols-2 lg:grid-cols-5" data-id="element-233" data-mp="2y485rzipgck9">
          {packItems.map(item => {
          const Icon = item.icon;
          return <li key={item.title} data-id="element-234" data-mp="26dc3tty6nsbr">
                <Icon className="h-6 w-6 text-pen" strokeWidth={1.75} aria-hidden="true" data-id="element-235" data-mp="9d7l5p58imi7" />
                <h4 className="mt-4 font-display text-[1.45rem] leading-tight text-ink" data-id="element-236" data-mp="9bd9l1fus6qs">{item.title}</h4>
                <p className="mt-2 text-sm leading-relaxed text-ink/70" data-id="element-237" data-mp="e9y36i0lns69">{item.text}</p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}